// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container_oTbrj{
  width: 100%;
  display: inline-flex;
  flex-direction: column;
  gap: 6px;
  padding: 0 10px;
  background: var(--white-background);
  border-radius: 20px 0 0 0;
}

.notificationCoontainer_xDFnU {
  display: flex;
  width: 100%;
  flex-direction: column;
  align-items: center;
  gap: 30px;
  padding-top: 20px;
  min-height: 100vh;
  overflow-y: scroll;

  &::-webkit-scrollbar {
    display: none;
  }
}
.delete_T1dM9 {
  font-weight: 600;
  cursor: pointer;
  color: var(--red-notification-color);
  text-decoration: underline;
  background-color: transparent;
  outline: none;
  border: none;
}

.searchIconsWrappers_RKpsk {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 18px;
  height: 18px;
  background: var(--ececf1-background);
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  border-radius: 3px;
}


.notification_hhUkC {
  display: flex;
  border: 1px solid var(--ececf1-border);
  padding: 20px;
  width: 90%;
  border-radius: 8px;
  flex-direction: column;
  -webkit-border-radius: 8px;
  -moz-border-radius: 8px;
  -ms-border-radius: 8px;
  -o-border-radius: 8px;

  p {
    margin: 0;
  }

  button {
    background-color: transparent;
    border: none;
    outline: none;
    font-weight: bolder;
    cursor: pointer;
  }
}
`, "",{"version":3,"sources":["webpack://./src/views/Dashboard/screens/NotificationsView/NotificationsView.module.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,oBAAoB;EACpB,sBAAsB;EACtB,QAAQ;EACR,eAAe;EACf,mCAAmC;EACnC,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,WAAW;EACX,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;;EAElB;IACE,aAAa;EACf;AACF;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,oCAAoC;EACpC,0BAA0B;EAC1B,6BAA6B;EAC7B,aAAa;EACb,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;EACjB,kBAAkB;AACpB;;;AAGA;EACE,aAAa;EACb,sCAAsC;EACtC,aAAa;EACb,UAAU;EACV,kBAAkB;EAClB,sBAAsB;EACtB,0BAA0B;EAC1B,uBAAuB;EACvB,sBAAsB;EACtB,qBAAqB;;EAErB;IACE,SAAS;EACX;;EAEA;IACE,6BAA6B;IAC7B,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,eAAe;EACjB;AACF","sourcesContent":[".container{\n  width: 100%;\n  display: inline-flex;\n  flex-direction: column;\n  gap: 6px;\n  padding: 0 10px;\n  background: var(--white-background);\n  border-radius: 20px 0 0 0;\n}\n\n.notificationCoontainer {\n  display: flex;\n  width: 100%;\n  flex-direction: column;\n  align-items: center;\n  gap: 30px;\n  padding-top: 20px;\n  min-height: 100vh;\n  overflow-y: scroll;\n\n  &::-webkit-scrollbar {\n    display: none;\n  }\n}\n.delete {\n  font-weight: 600;\n  cursor: pointer;\n  color: var(--red-notification-color);\n  text-decoration: underline;\n  background-color: transparent;\n  outline: none;\n  border: none;\n}\n\n.searchIconsWrappers {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 18px;\n  height: 18px;\n  background: var(--ececf1-background);\n  cursor: pointer;\n  user-select: none;\n  border-radius: 3px;\n}\n\n\n.notification {\n  display: flex;\n  border: 1px solid var(--ececf1-border);\n  padding: 20px;\n  width: 90%;\n  border-radius: 8px;\n  flex-direction: column;\n  -webkit-border-radius: 8px;\n  -moz-border-radius: 8px;\n  -ms-border-radius: 8px;\n  -o-border-radius: 8px;\n\n  p {\n    margin: 0;\n  }\n\n  button {\n    background-color: transparent;\n    border: none;\n    outline: none;\n    font-weight: bolder;\n    cursor: pointer;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `container_oTbrj`,
	"notificationCoontainer": `notificationCoontainer_xDFnU`,
	"delete": `delete_T1dM9`,
	"searchIconsWrappers": `searchIconsWrappers_RKpsk`,
	"notification": `notification_hhUkC`
};
export default ___CSS_LOADER_EXPORT___;
